// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyEducation_faculty-detail-education__mvajJ {
  width: 100%;
}
.FacultyEducation_faculty-detail-education__mvajJ .FacultyEducation_faculty-detail-education-landscape__gkDoS {
  width: 100%;
  font-size: 14px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  margin-top: 15px;
}
.FacultyEducation_faculty-detail-education__mvajJ .FacultyEducation_faculty-detail-education-landscape__gkDoS .FacultyEducation_list-education-title__oZVeG {
  margin-bottom: 12px !important;
  display: flex;
  align-items: center;
}
.FacultyEducation_faculty-detail-education__mvajJ .FacultyEducation_faculty-detail-education-landscape__gkDoS .FacultyEducation_list-education-title__oZVeG .FacultyEducation_title__RoQ2q {
  font-weight: bold;
  font-size: 16px;
  margin-right: 15px !important;
}
.FacultyEducation_faculty-detail-education__mvajJ .FacultyEducation_faculty-detail-education-landscape__gkDoS .FacultyEducation_see-more__TZREl {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.FacultyEducation_faculty-detail-education__mvajJ .FacultyEducation_faculty-detail-education-landscape__gkDoS .FacultyEducation_see-more__TZREl p {
  cursor: pointer;
  color: var(--explore-color);
  font-size: 14px;
}
.FacultyEducation_faculty-detail-education__mvajJ .FacultyEducation_faculty-detail-education-mobile__nIklu {
  display: none;
}
@media only screen and (max-width: 900px) {
  .FacultyEducation_faculty-detail-education__mvajJ .FacultyEducation_faculty-detail-education-landscape__gkDoS {
    display: none !important;
  }
  .FacultyEducation_faculty-detail-education__mvajJ .FacultyEducation_faculty-detail-education-mobile__nIklu {
    display: block;
  }
}

.FacultyEducation_education__i9McG {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  height: fit-content;
}
.FacultyEducation_education__i9McG .FacultyEducation_education-info__0yIYz {
  display: flex;
  align-items: flex-start;
}
.FacultyEducation_education__i9McG .FacultyEducation_education-info__0yIYz .anticon {
  margin-top: 2px;
}
.FacultyEducation_education__i9McG .FacultyEducation_education-info__0yIYz .FacultyEducation_title__RoQ2q {
  margin-left: 10px;
}
.FacultyEducation_education__i9McG .FacultyEducation_education-info__0yIYz .FacultyEducation_title__RoQ2q .FacultyEducation_inst-name__q6IjU:hover {
  color: var(--blue);
  cursor: pointer;
  text-decoration: underline;
}
.FacultyEducation_education__i9McG .FacultyEducation_education-info__0yIYz .FacultyEducation_title__RoQ2q .FacultyEducation_sub-title__ZoGVA {
  color: var(--dark-grey);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/FacultyEducation/FacultyEducation.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAAE;EACE,WAAA;EACA,eAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAEJ;AADI;EACE,8BAAA;EACA,aAAA;EACA,mBAAA;AAGN;AAFM;EACE,iBAAA;EACA,eAAA;EACA,6BAAA;AAIR;AADI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAGN;AAFM;EACE,eAAA;EACA,2BAAA;EACA,eAAA;AAIR;AAAE;EACE,aAAA;AAEJ;AAAE;EACE;IACE,wBAAA;EAEJ;EAAE;IACE,cAAA;EAEJ;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAEF;AADE;EACE,aAAA;EACA,uBAAA;AAGJ;AAFI;EACE,eAAA;AAIN;AAFI;EACE,iBAAA;AAIN;AAFQ;EACE,kBAAA;EACA,eAAA;EACA,0BAAA;AAIV;AADM;EACE,uBAAA;AAGR","sourcesContent":[".faculty-detail-education {\n  width: 100%;\n  .faculty-detail-education-landscape {\n    width: 100%;\n    font-size: 14px;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    padding: 20px;\n    margin-top: 15px;\n    .list-education-title {\n      margin-bottom: 12px !important;\n      display: flex;\n      align-items: center;\n      .title {\n        font-weight: bold;\n        font-size: 16px;\n        margin-right: 15px !important;\n      }\n    }\n    .see-more {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      p {\n        cursor: pointer;\n        color: var(--explore-color);\n        font-size: 14px;\n      }\n    }\n  }\n  .faculty-detail-education-mobile {\n    display: none;\n  }\n  @media only screen and (max-width: 900px) {\n    .faculty-detail-education-landscape {\n      display: none !important;\n    }\n    .faculty-detail-education-mobile {\n      display: block;\n    }\n  }\n}\n.education {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  height: fit-content;\n  .education-info {\n    display: flex;\n    align-items: flex-start;\n    :global(.anticon) {\n      margin-top: 2px;\n    }\n    .title {\n      margin-left: 10px;\n      .inst-name {\n        &:hover {\n          color: var(--blue);\n          cursor: pointer;\n          text-decoration: underline;\n        }\n      }\n      .sub-title {\n        color: var(--dark-grey);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-detail-education": `FacultyEducation_faculty-detail-education__mvajJ`,
	"faculty-detail-education-landscape": `FacultyEducation_faculty-detail-education-landscape__gkDoS`,
	"list-education-title": `FacultyEducation_list-education-title__oZVeG`,
	"title": `FacultyEducation_title__RoQ2q`,
	"see-more": `FacultyEducation_see-more__TZREl`,
	"faculty-detail-education-mobile": `FacultyEducation_faculty-detail-education-mobile__nIklu`,
	"education": `FacultyEducation_education__i9McG`,
	"education-info": `FacultyEducation_education-info__0yIYz`,
	"inst-name": `FacultyEducation_inst-name__q6IjU`,
	"sub-title": `FacultyEducation_sub-title__ZoGVA`
};
export default ___CSS_LOADER_EXPORT___;
